export function computeRemaining(timer) {
  if (!timer) return 0;
  if (!timer.running) return timer.remaining_ms;
  const elapsed = Date.now() - new Date(timer.updated_at).getTime();
  return Math.max(0, timer.remaining_ms - elapsed);
}

export function fmtClock(ms) {
  const total = Math.ceil(ms / 1000);
  const m = Math.floor(total / 60);
  const s = total % 60;
  return `${m}:${String(s).padStart(2, "0")}`;
}
